export enum PurchaseSupplierLinkStatus {
  PENDENTE = 'PENDENTE',
  APROVADO = 'APROVADO',
  REJEITADO = 'REJEITADO'
}

export type PurchaseSupplierSource = 'Manual' | 'Integração' | 'eBarn' | 'eBarn CotAI';

export interface PurchaseSupplier {
  id: string;
  name: string;
  fantasyName: string;
  cnpj: string;
  stateRegistration?: string;
  phone: string;
  email: string;
  isVerified: boolean;
  source?: PurchaseSupplierSource;
  linkStatus?: PurchaseSupplierLinkStatus;
}

export interface PurchaseSupplierCreate extends PurchaseSupplier {
  purchaseId: string;
  productId?: string;
}
